import { Columns, EdmColumns } from 'constants/columns';

/**
 * If all of these will be checked, then the whole edm won't be exported.
 */
const EDM_FILTERS = [
    EdmColumns.NAME,
    EdmColumns.EMAILS,
    EdmColumns.PHONES,
    EdmColumns.ADDRESSES,
];

const WHOLE_EDM_KEY = 'wholeEdm';

/**
 * Not actual RegExp, but a string that will be used to create RegExp.
 */
const COLUMN_REGEX_MAP = {
    [WHOLE_EDM_KEY]: [
        'EDM \\d (First name|Last name)',
        'Email \\d*',
        'Phone \\d*',
        'EDM \\d (Street|City|State|Zip) \\d',
        'Age',
    ],
    [Columns.ADDRESS]: [
        'Property Address',
        'Property City',
        'Property State',
        'Property Zip',
    ],
    [EdmColumns.NAME]: ['EDM \\d (First name|Last name)'],
    [EdmColumns.EMAILS]: ['Email \\d*'],
    [EdmColumns.PHONES]: ['Phone \\d*'],
    [EdmColumns.ADDRESSES]: ['EDM \\d (Street|City|State|Zip) \\d'],
};

export const createFilterRegex = (selectedOptions: string[]) => {
    const shouldRemoveWholeEDM = EDM_FILTERS.every((opt) =>
        selectedOptions.includes(opt as EdmColumns)
    );

    const options = [
        ...selectedOptions,
        shouldRemoveWholeEDM ? WHOLE_EDM_KEY : '',
    ];

    const columnsToRemove = [
        '(?!)', // Negative lookahead, won't match anything
        ...options
            // Remove EDM columns, because they would be addded twice otherwise
            // Also remove empty string, cause that would match everything
            .filter((val) =>
                shouldRemoveWholeEDM
                    ? !EDM_FILTERS.includes(val as EdmColumns)
                    : Boolean(val)
            )
            .flatMap(
                (opt) => COLUMN_REGEX_MAP[opt as keyof typeof COLUMN_REGEX_MAP]
            ),
    ];
    // Creates RegExp from strings
    // wraps each string in (), so that it will be matched as a group
    // and joins all groups with | so it's valid OR regex
    return new RegExp(`${columnsToRemove.map((s) => `(${s})`).join('|')}`, 'u');
};
